<template>
  <div class="common-title-underline" :class="{ gray: gray }">
    <div class="title-container">
      <p class="title">{{ title }}</p>
      <p v-if="chips" v-for="chip of chips" :style="{ backgroundColor: chip.backgroundColor }" class="chip">
        {{ chip.title }}</p>
    </div>
    <div class="dotted-underline"></div>
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    title: string
    chips?: { title: string, backgroundColor: string }[]
    gray?: boolean
  }>(),
  {
    gray: false,
  },
)
</script>

<style lang="scss" scoped>
.common-title-underline {
  margin-bottom: var(--spacer);

  .title-container {
    display: flex;
    align-items: center;
    gap: 20px;
    padding-bottom: var(--spacer-0_5);
  }


  .title {
    font-size: 32px;
    text-transform: uppercase;
    color: var(--vc-primary);
  }

  .chip {
    font-size: 26px;
    color: white;
    font-weight: 600;
    padding: 0 5px;
  }

  .dotted-underline {
    display: flex;

    &::before {
      content: '';
      display: block;
      background-image: url('../../src/assets/images/arrow-underline-blue.png');
      background-size: auto 14px;
      background-repeat: no-repeat;
      width: 44px;
      height: 14px;
    }

    &::after {
      content: '';
      flex: 1 0 44px;
      display: block;
      background-image: linear-gradient(to right, var(--vc-primary) 33%, rgba(255, 255, 255, 0) 0%);
      background-position: bottom;
      background-size: 3px 1px;
      background-repeat: repeat-x;
      background-position: top;
      width: 100%;
    }
  }

  &.gray {
    .title {
      color: var(--vc-gray4);
    }

    .dotted-underline {
      &::before {
        background-image: url('../../src/assets/images/arrow-underline-gray.png');
      }

      &::after {
        content: '';
        background-image: linear-gradient(to right, var(--vc-gray4) 33%, rgba(255, 255, 255, 0) 0%);
      }
    }
  }
}
</style>
